import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
var RichText = function (_a) {
    var _b = _a.content, content = _b === void 0 ? '' : _b;
    return (_jsx("div", { className: 'rich-text', dangerouslySetInnerHTML: {
            __html: content
                .replace(/<ol>\s*<li data-list="bullet"/g, '<ul><li')
                .replace(/<\/li>\s*<\/ol>/g, '</li></ul>')
        } }));
};
export default RichText;
